import React from 'react';

/**
 * Skip-to-content link for keyboard and screen-reader users. Rendered as the
 * first focusable element in the page; becomes visible only when focused.
 */
const SkipLink: React.FC = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-elev8-blue focus:text-white focus:rounded-md focus:shadow-lg"
  >
    Skip to content
  </a>
);

export default SkipLink;
